export enum CartStepName {
  Step1 = "STEP_1",
  Step2 = "STEP_2",
  Step3 = "STEP_3",
  ThankYou = "THANK_YOU"
}
